<template>
    <div>
        <div v-for="option in options" :key="option.id" class="mb-10">
            <label class="container-radio">
              <input v-on:input="onUpdate(option)"
                    :checked="option.id == currentValue"
                    :id="getInputKey(option)"
                    :name="getInputKey()"
                    type="radio">
                {{ option.name }}
              <span class="checkmark"></span>
            </label>
            
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            randomKey: Math.floor(Math.random() * 1000000),
        }
    },

    props: ['value', 'label', 'config'],

    computed: {
        options() {
            return _.get(this.config, 'values', [])
                .map(value => {
                    if (_.isObject(value)) return value;

                    return { id: value, name: value };
                });
        },

        description() {
            return _.get(this.config, 'description', '');
        },

        defaultValue() {
            return _.get(this.config, 'default');
        },

        currentValue() {
            return this.value || _.get(this.config, 'default');
        },
    },

    methods: {
        onUpdate(value) {
            this.$emit('input', value.id);
        },

        getInputKey(value = null) {
            const suffix = value ? `-${value.id}` : '';
            return `-radio-${this.randomKey}${suffix}`;
        },
    }
}
</script>
